import { __, compose, propOr } from 'ramda';
import { handleActions } from 'redux-actions';

import { propFromPayload } from 'app/reducers/helpers';
import { USER_FETCHED } from 'app/features/user/actionTypes';
import {
  FAN,
  PREMIUM,
  PREMIUM_PLUS,
  SUPER_FAN,
} from 'app/features/user/constants/accessTypes';

const stateByAccessType = {
  [PREMIUM]: {
    titleKey: 'success_title_premium',
    subtitleKey: 'success_subtitle_premium',
  },
  [PREMIUM_PLUS]: {
    titleKey: 'success_title_premium',
    subtitleKey: 'success_subtitle_premium',
  },
  [FAN]: {
    titleKey: 'success_title_fanpack',
    subtitleKey: 'success_subtitle_fanpack',
  },
  [SUPER_FAN]: {
    titleKey: 'success_title_super_fanpack',
    subtitleKey: 'success_subtitle_super_fanpack',
  },
};

const heroBlock = handleActions(
  {
    [USER_FETCHED]: compose(
      propOr({}, __, stateByAccessType),
      propFromPayload('accessType'),
    ),
  },
  {},
);

export { heroBlock };

export default heroBlock;
